import axios from 'axios';
import buildUrl from 'build-url-ts';
import {
  IIntegration,
} from 'src/types/integrations/docusign';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/2.0/integrations/docusign`;

export const docusignApi = {
  fetchIntegration: async (): Promise<IIntegration | null> => {
    try {
      const response = await axios.get<IIntegration>(BASE_URL);
      return response.data ?? null;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  authenticate: async (code: string): Promise<IIntegration> => {
    const url = buildUrl(BASE_URL, {
      queryParams: { code },
    });
    const response = await axios.post<IIntegration>(url);
    return response.data;
  },

  deactivate: async (): Promise<IIntegration> => {
    const response = await axios.delete<IIntegration>(BASE_URL);
    return response.data;
  },
};
